import { AfterViewInit, booleanAttribute, Component, input, OnDestroy, OnInit, output, viewChild } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSlideToggle } from '@angular/material/slide-toggle';

import { AppMaterialModule } from '../../../material.module';
import { fieldColor, labelPosition, TFieldColor, TLabelPosition } from '../../models/form-field-options';
import { _BaseControlComponent } from '../../components/_base-control.component';

@Component({
    selector: 'app-slide-toggle-control',
    templateUrl: './slide-toggle-control.component.html',
    styleUrls: [
        './slide-toggle-control.component.scss',
        '../../control.scss',
    ],
    standalone: true,
    host: {
        '[class.readonly]': 'readonly$$()'
    },
    imports: [
        AppMaterialModule,
        ReactiveFormsModule,
    ],
})
export class SlideToggleControlComponent
    extends _BaseControlComponent
    implements OnInit, AfterViewInit, OnDestroy
{
    input_ariaLabel$$          = input<string>('',                            { alias: 'ariaLabel' });
    input_color$$              = input<TFieldColor>(fieldColor.primary,       { alias: 'color' });
    input_disableRipple$$      = input(false,                                 { transform: booleanAttribute, alias: 'disableRipple' });
    input_hideIcon$$           = input(false,                                 { transform: booleanAttribute, alias: 'hideIcon' });
    input_label$$              = input<string>('',                            { alias: 'label' });
    input_labelPosition$$      = input<TLabelPosition>(labelPosition.after,   { alias: 'labelPosition' });
    input_required$$           = input(false,                                 { transform: booleanAttribute, alias: 'required' });

    // Alleen bij een wijziging door de gebruiker (niet bij setValue van buitenaf).
    out_valueChange = output<boolean>({ alias: 'valueChange' });

    override attributes$$        = this._input_attributes$$;
    override autofocus$$         = this._input_autofocus$$;
    override control$$           = this._input_control$$;
    override controlName$$       = this._input_controlName$$;
    override disabled$$          = this._input_disabled$$;
    override errorShow$$         = this._input_errorShow$$;
    override errorStateMatcher$$ = this._input_errorStateMatcher$$;
    override id$$                = this._input_id$$;
    override lockOnLoad$$        = this._input_lockOnLoad$$;
    override placeholder$$       = this._input_placeholder$$;
    override readonly$$          = this._input_readonly$$;
    override subscriptHide$$     = this._input_subscriptHide$$;
    override tabIndex$$          = this._tabIndex$$;
    override value$$             = this._input_value$$;
    override valueReset$$        = this._input_valueReset$$;

    private readonly __slideToggle$$ = viewChild(MatSlideToggle);

    override get label() { return this.input_label$$(); }

    override ngOnInit(): void {
        super._ngOnInit();
    }

    emit_valueChange(checked: boolean): void {
        this.out_valueChange.emit(checked);
    }

    ngAfterViewInit(): void {
        if (this.autofocus$$()) { this.__slideToggle$$()?.focus(); }
    }

    override ngOnDestroy(): void {
        super._ngOnDestroy();
    }
}
